/* global google, home_marker, car_marker */
import '../mulberrys/richmarker';
export default {
  init: function () {
    var self = this;
    var home_marker = null;
    var driver_marker = null;

    var map = new google.maps.Map(
      document.getElementById( "driver_location" ),
      {
        center: {lat: 44.968032, lng: -93.259883},
        zoom: 15,
      }
    );

    var driverLocationInterval = setInterval(function () {
      // eslint-disable-next-line no-undef
      jQuery.get(ajax_vars.ajax_url, {action: 'get_my_driver_location', 'security': ajax_vars.ajax_nonce}, function (response) {

        if ( ! response.success ) {
          clearInterval(driverLocationInterval);
          return;
        }

        // First time we create the marker, next time, we just move the marker around.
        if ( ! driver_marker ) {
          driver_marker = self.createDriverMarker( map, response.data.driver );
        } else {
          driver_marker.setPosition( new google.maps.LatLng( response.data.driver.location.lat, response.data.driver.location.lon));
        }

        if ( response.data.driver.heading ) {
          self.rotateDriverMarker( response.data.driver.heading );
        }

        // Only set home marker once.
        if ( ! home_marker ) {
          home_marker = self.addHomeMarker( map, response.data.home);
        }

        self.calculateBounds( map, home_marker, driver_marker);
      }, 'JSON');

    }, 5000);

  },
  rotateDriverMarker: function( heading ) {
    const marker = document.querySelector(`[src="${car_marker}"]`);
    if ( marker ) { // when it hasn't loaded, it's null
      const actualAngle = heading - 90;
      marker.style.transform = `rotate(${actualAngle}deg)`;
    }
  },
  createDriverMarker: function( map, data ) {

    const icon = {
      url: car_marker,
      scaledSize: new window.google.maps.Size(35, 35),
      anchor: { x: 20, y: 20 },
    }
    /**var truck_icon = {
      path: "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z",
      fillColor: '#858383',
      fillOpacity: 1,
      strokeWeight: 0,
      scale: 0.07,
      size: new google.maps.Size(100 , 120),
      scaledSize: new google.maps.Size(50, 60),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(24, 55),
    }**/

    return new google.maps.Marker(
      {
        position: new google.maps.LatLng( data.location.lat, data.location.lon ),
        map: map,
        icon: icon,
      }
    );
  },
  addHomeMarker: function (map, home) {
    var home_location = {
      lat: home.lat,
      lng: home.lng,
      icon: {
        url: home_marker,
        size: new google.maps.Size(100 , 120),
        scaledSize: new google.maps.Size(50, 60),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(24, 55),
      },
    };

    return new google.maps.Marker(
      {
        position: new google.maps.LatLng( home_location.lat, home_location.lng ),
        map: map,
        icon: home_location.icon,
      }
    );
  },
  calculateBounds: function( map, home, driver) {
    var bounds = new google.maps.LatLngBounds();
    bounds.extend(home.getPosition());
    bounds.extend(driver.getPosition());
    map.fitBounds(bounds);
  },
  /**geoDecodeAddress: function ( geocoder, address ) {
    var geocoder = new google.maps.Geocoder();
		return geocoder.geocode(
			{ 'address': address},
			function(results, status) {
				if (status == 'OK') {
					return results[0].geometry.location;
				} else {
					return false;
				}
			}
		);
	}**/
};



// WEBPACK FOOTER //
// ./scripts/routes/order-driver-tracking.js